<template>
  <div :style="{ backgroundImage: `url(${weddingBackground})` }"
       class="header">
      <img :src="logo"/>
  </div>
</template>

<script>
import weddingBackground from '@/assets/wedding-background.jpeg';
import logo from '@/assets/logo.svg';

export default {
  name: 'Header',
  data() {
    return {
      weddingBackground,
      logo,
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 250px;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;

  & img {
    width: 150px;
  }
}
</style>
